import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStack: "general", //Valid values: "general", "singleSleeper", "doubleSleeper"
  currentStepGeneral: 0,
  currentStepSingleSleeperMattressBuilder: 0,
  currentStepDoubleSleeperMattressBuilder: 0,
  checkErrors: false,
  currentlyEditingSleeper: 1,
  isIncorporateModalOpen: false,
  isSummaryModalOpen: false,
  isSaveForLaterModalOpen: false,
  saveForLaterModalSeen: true,      // Ben Inkster: Set this to "false" to have the modal pop up
  loading: false,
  error: false,
};

export const customNavigationSlice = createSlice({
  name: "customNavigation",
  initialState,
  reducers: {
    setCurrentStack: (state, action) => {
      state.currentStack = action.payload;
    },
    setCurrentStepGeneral: (state, action) => {
      state.currentStepGeneral = action.payload;
    },
    setCurrentStepSingleSleeperMattressBuilder: (state, action) => {
      state.currentStepSingleSleeperMattressBuilder = action.payload;
    },
    setCurrentStepDoubleSleeperMattressBuilder: (state, action) => {
      state.currentStepDoubleSleeperMattressBuilder = action.payload;
    },
    setCheckErrors: (state, action) => {
      state.checkErrors = action.payload;
    },
    setIsIncorporateModalOpen: (state, action) => {
      state.isIncorporateModalOpen = action.payload;
    },
    setIsSummaryModalOpen: (state, action) => {
      state.isSummaryModalOpen = action.payload;
    },
    setCurrentlyEditingSleeper: (state, action) => {
      state.currentlyEditingSleeper = action.payload;
    },
    setIsSaveForLaterModalOpen: (state, action) => {
      state.isSaveForLaterModalOpen = action.payload;
    },
    setSaveForLaterModalSeen: (state, action) => {
      state.saveForLaterModalSeen = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      // .addCase(fetchCustomerByEmail.pending, state => {
      //     // console.log("inside fetchCustomerByEmail pending");
      //     state.loading = true;
      // })
      // .addCase(fetchCustomerByEmail.rejected, state => {
      //     // console.log("inside fetchCustomerByEmail rejected");
      //     state.loading = true;
      // })
      // .addCase(fetchCustomerByEmail.fulfilled, state => {
      //     // console.log("inside fetchCustomerByEmail fulfilled");
      //     state.loading = false;
      //     return state;
      // })

      .addDefaultCase((state, action) => {
        return state;
      });
  },
});

//THUNKS
// export const fetchCustomerByEmail = createAsyncThunk(
//     "slices/queryCustomer",
//     async email => {
//         const response = await CustomerService.queryCustomer({ email });
//         if (response.isSuccessful) {
//             return response;
//         } else {
//             setCustomerError();
//         }
//     }
// );

export const {
  setCurrentStack,
  setCurrentStepGeneral,
  setCurrentStepSingleSleeperMattressBuilder,
  setCurrentStepDoubleSleeperMattressBuilder,
  setCheckErrors,
  setCurrentlyEditingSleeper,
  setIsIncorporateModalOpen,
  setIsSummaryModalOpen,
  setIsSaveForLaterModalOpen,
  setSaveForLaterModalSeen,
} = customNavigationSlice.actions;

export default customNavigationSlice.reducer;

// SELECTORS
export const currentStackSelector = state =>
  state.customNavigation.currentStack;
export const currentStepGeneralSelector = state =>
  state.customNavigation.currentStepGeneral;
export const currentStepSingleSleeperMattressBuilderSelector = state =>
  state.customNavigation.currentStepSingleSleeperMattressBuilder;
export const currentStepDoubleSleeperMattressBuilderSelector = state =>
  state.customNavigation.currentStepDoubleSleeperMattressBuilder;
export const checkErrorsSelector = state =>
  state.customNavigation.checkErrors;
export const currentlyEditingSleeperSelector = state =>
  state.customNavigation.currentlyEditingSleeper;
export const isIncorporateModalOpenSelector = state =>
  state.customNavigation.isIncorporateModalOpen;
export const isSummaryModalOpenSelector = state =>
  state.customNavigation.isSummaryModalOpen;
export const isSaveForLaterModalOpenSelector = state =>
  state.customNavigation.isSaveForLaterModalOpen;
export const saveForLaterModalSeenSelector = state =>
  state.customNavigation.saveForLaterModalSeen;
